import { Box, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Link, useHistory } from "react-router-dom";
import { handleLogout } from "utils/auth";
import { useAppContext } from "context/Context";
import { ACTIONS } from "context/reducer";

export default function SomethingWentWrong() {
  const history = useHistory();

  const { dispatch } = useAppContext();

  const logout = () => {
    handleLogout();

    history.push("/login");
    dispatch({ type: ACTIONS.LOGOUT });
  };

  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      px={2}
    >
      <ErrorOutlineIcon
        color="error"
        sx={{ fontSize: 64, mb: 2, animation: "bounce 1s infinite" }}
      />
      <Typography variant="h5" color="text.primary" sx={{ mb: 2 }}>
        Ooops, something went wrong
      </Typography>
      <Button
        variant="contained"
        color="primary"
        LinkComponent={Link}
        to="/login"
        data-testid="login-button"
        onClick={logout}
      >
        Login
      </Button>
    </Box>
  );
}
